//
//
//
//
//
//
//
//
//
//
//

import Money from '@motionelements/money';

export default {
  name: 'Price',
  props: {
    element: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isFree() {
      return _.get(this.element, 'free') === true;
    },
    price() {
      const price = _.get(this.element, 'price');

      if (price > 0) {
        return Money({ amount: price, currency: this.element.currency });
      }

      return null;
    },
  },
};
